import { TableProductKit } from "../components/TableProductKit";

export const ProductKitPage = () => {
  return <TableProductKit />;
};
